import React, { useEffect, useState } from 'react'

import Public from '@/helpers/PageTypes/Public'

import SEO from '@/components/SEO'
import BackToTopButton from '@/components/BackToTopButton'
import HeaderUnsigned from '@/components/LandingPage/Header'
import Newsletter from '@/components/LandingPage/Newsletter'
import FooterUnsigned from '@/components/LandingPageV2/Shared/Footer'
import ContentsPage from '@/components/LandingPage/PageComponents/Contents'

import { useTranslation } from 'react-i18next'

const ContentsV2 = () => {
  const { t } = useTranslation()

  const [pageTitle, setPageTitle] = useState(' | Contents')

  useEffect(() => {
    setPageTitle(` | ${t('titles.contents')}`)
  }, [t])

  return (
    <Public>
      <SEO title={pageTitle} />

      <HeaderUnsigned pageName="contents" />
      <ContentsPage />
      <Newsletter />
      <FooterUnsigned />
      <BackToTopButton threshold={700} />
    </Public>
  )
}

export default ContentsV2
